import React from 'react';
import { getGridStyle } from './grid-options';
import styles from './grid.module.scss';
import { Focusable } from '../form/focusable';
import { useConfig } from '../../../../contexts/config-context';
import classNames from 'classnames';
import animationStyles from '../../../../animations/grid-animations.module.scss';
export const Grid = _ref => {
  let {
    items,
    layout,
    isRTL
  } = _ref;
  const {
    isMobile,
    enableAnimations
  } = useConfig();
  const reactElementsByRow = getReactElementsByRow(items);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    dir: isRTL ? 'rtl' : ''
  }, reactElementsByRow.map((rowData, index) => {
    const fieldId = rowData.firstFieldId;
    const key = isMobile && fieldId || index;
    return /*#__PURE__*/React.createElement(Focusable, {
      key: fieldId,
      fieldId: fieldId
    }, /*#__PURE__*/React.createElement("div", {
      key: key,
      style: getGridStyle({
        layout
      }),
      className: classNames(styles.grid, styles.column, {
        [animationStyles.animations]: enableAnimations
      })
    }, rowData.elements));
  }));
};
function getReactElementsByRow(items) {
  const reactElementsByRow = items.reduce((result, item) => {
    const row = item.layout.row;
    const element = /*#__PURE__*/React.cloneElement(item.component, {
      key: item.id
    });
    if (result[row]) {
      result[row].elements.push(element);
    } else {
      result[row] = {
        elements: [element],
        firstFieldId: item.id
      };
    }
    return result;
  }, []);
  return reactElementsByRow;
}
//# sourceMappingURL=grid.js.map